import React, { useContext, useEffect, useState } from "react";
import { DarkModeContext } from "../../context/DarkModeContext";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import logo from "../../assets/img/logo.png";
import BienvenidoAdmin from "../../components/administracion/BienvenidoAdmin";
import TituloPagina from "../../components/comunes/TituloPagina";
import PanelInformeUIF from "../../components/compliance/PanelInformeUIF";
import Footer from "../../components/comunes/Footer";
import { getToken } from "../../utils/auth";

const InformeUIF = () => {
    const apiUrlToken = process.env.REACT_APP_API_TOKEN;
    const { darkMode } = useContext(DarkModeContext);
    const [autorizado, setAutorizado] = useState(false);
    const navegacion = useNavigate();

    useEffect(() => {
        const verificarToken = async () => {
            const token = getToken();
            if (!token) {
                redireccionarConMensaje("Sesion expirada o token invalido.", "Inicie sesion nuevamente.");
                return;
            }

            try {
                const response = await fetch(apiUrlToken, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ Token: token }),
                });

                if (response.ok) {
                    const data = await response.json();
                    if (data !== 13) {
                        redireccionarConMensaje("Acceso denegado.", "No tiene permisos para este panel.");
                    } else {
                        setAutorizado(true);
                    }
                } else if (response.status === 401) {
                    redireccionarConMensaje("Sesion expirada o token invalido.", "Inicie sesion nuevamente.");
                }
            } catch {
                redireccionarConMensaje("Error de conexion.", "No se pudo verificar la sesion.");
            }
        };

        const redireccionarConMensaje = (titulo, texto) => {
            sessionStorage.removeItem("token");
            Swal.fire({
                title: titulo,
                text: texto,
                imageUrl: logo,
                imageWidth: 100,
                imageHeight: 30,
                imageAlt: "Logo",
                confirmButtonText: "Ok",
                timer: 5000,
                allowOutsideClick: true,
                customClass: {
                    container: darkMode ? "swal2-container--dark" : "swal2-container--light",
                    confirmButton: "my-swal-button",
                },
            }).then(() => {
                navegacion("/");
                window.location.reload();
            });
        };

        verificarToken();
    }, [apiUrlToken, darkMode, navegacion]);

    return (
        <div className="d-flex flex-column min-vh-100" translate="no">
            <div className="pt-5">
                <BienvenidoAdmin />
            </div>
            <div>
                <TituloPagina title="Informe UIF" />
            </div>
            <div>
                {autorizado && <PanelInformeUIF darkMode={darkMode} />}
            </div>
            <div translate="no" className="py-4 mt-auto">
                <Footer />
            </div>
        </div>
    );
};

export default InformeUIF;
